const units = {}

// === IMPORT LOCALLY-SCOPED JOBS === //
//import games from "@frog/source/data/games/index.js"
// Object.values(games).forEach((game) => {
//     if(game.localJobs != undefined) {
//         game.localJobs.forEach((job) => {units[game.slug + job.jobKey] = job})
//     }
// })
import pirateJobs from "@frog/source/data/games/pirates/unitJobs.js"
Object.values(pirateJobs).forEach((job) => {
    units["pirates/" + job.jobKey] = job
    units["pirates/" + job.jobKey].affiliation = "bad"
})
import heroJobs from "@frog/source/data/games/hero/unitJobs.js"
Object.keys(heroJobs).forEach((jobKey) => {
    units[jobKey] = heroJobs[jobKey]
    units[jobKey].affiliation = "bad"
})

import emberUnitJobs from "@frog/source/data/games/ember/unitJobs.js"
Object.keys(emberUnitJobs).forEach((jobKey) => {
    units[jobKey] = emberUnitJobs[jobKey]
})

import bookUnitJobs from "@frog/source/data/games/book/unitJobs.js"
Object.keys(bookUnitJobs).forEach((jobKey) => {
    units[jobKey] = bookUnitJobs[jobKey]
})

/////////////
// RANGER //
///////////

units["dagger"] = {
    "jobKey": "dagger",
    "jobName": "Thief",
    "fequivalent": "Thief",
    "maxhealth": 20,
    "moverange": 2,
    "defense": 0,
    "resistance": 0,
    "affiliation": "bad",

    "primaryItem": {
        "name": "Daggers",
        "element": "fire",
        "attacktype": "steel",
        "attackrange": 2,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "daggers",
    },

    "facts": [
        "Attacks from 2 tiles away. Strong against axes and guns.",
    ]
}

units["bow"] = {
    "jobKey": "bow",
    "jobName": "Archer",
    "fequivalent": "Archer",
    "moverange": 2,
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "affiliation": "bad",

    "primaryItem": {
        "name": "Bow",
        "element": "water",
        "attacktype": "steel",
        "attackrange": 2,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "bow",
    },

    "facts": [
        "Attacks from 2 tiles away. Strong against swords and daggers.",
    ]
}

units["gun"] = {
    "jobKey": "gun",
    "jobName": "Gunman",
    "fequivalent": "Pirate",
    "moverange": 2,
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "affiliation": "bad",

    "primaryItem": {
        "name": "Gun",
        "element": "earth",
        "attacktype": "steel",
        "attackrange": 2,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "gun",
    },

    "facts": [
        "Attacks from 2 tiles away. Strong against spears and bows.",
    ]
}

/////////////////////
// RANGER MOUNTED //
///////////////////

units["bowcavalier"] = {
    "jobKey": "bowcavalier",
    "jobName": "Bowcavalier",
    "fequivalent": "Nomad",
    "moverange": 3,
    "movetype": "mounted",
    "moveaudio": "Unit:Move:Horse",
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "affiliation": "bad",

    "primaryItem": {
        "name": "Bow",
        "element": "water",
        "attacktype": "steel",
        "attackrange": 2,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "bow",
    },
}
// TODO: daggerhorse?
// TODO: gunhorse?

//////////////
// FIGHTER //
////////////

units["sword"] = {
    "jobKey": "sword",
    "jobName": "Swordsman",
    "fequivalent": "Mercenary",
    "attacktype": "steel",
    "moverange": 2,
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "affiliation": "bad",

    "primaryItem": {
        "name": "Sword",
        "element": "fire",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "sword",
    },

    "facts": [
        "Strong against spears and bows.",
    ]
}

units["spear"] = {
    "jobKey": "spear",
    "jobName": "Spearman",
    "fequivalent": "Soldier",
    "moverange": 2,
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "affiliation": "bad",

    "primaryItem": {
        "name": "Spear",
        "element": "water",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "spear",
    },

    "facts": [
        "Strong against axes and guns.",
    ]
}

units["axe"] = {
    "jobKey": "axe",
    "jobName": "Axeman",
    "fequivalent": "Fighter",
    "attackrange": 1,
    "moverange": 2,
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "affiliation": "bad",

    "primaryItem": {
        "name": "Axe",
        "element": "earth",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "axe",
    },

    "facts": [
        "Strong against spears and bows.",
    ]
}

units["hammer"] = units["axe"] // an alias

//////////////////////
// FIGHTER MOUNTED //
////////////////////

units["swordcavalier"] = {
    "jobKey": "swordcavalier",
    "jobName": "Swordcavalier",
    "fequivalent": "Cavalier",
    "moverange": 3,
    "movetype": "mounted",
    "moveaudio": "Unit:Move:Horse",
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "affiliation": "bad",
    "decalImageKey": "red-helmet",

    "primaryItem": {
        "name": "Sword",
        "element": "fire",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "sword",
    },
}

units["spearcavalier"] = {
    "jobKey": "spearcavalier",
    "jobName": "Spearcavalier",
    "fequivalent": "Paladin",
    "moverange": 3,
    "movetype": "mounted",
    "moveaudio": "Unit:Move:Horse",
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "affiliation": "bad",
    "decalImageKey": "blue-helmet",

    "primaryItem": {
        "name": "Spear",
        "element": "water",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "spear",
    },
}

units["axecavalier"] = {
    "jobKey": "axecavalier",
    "jobName": "Axecavalier", // ??
    "fequivalent": "Warlord",
    "moverange": 3,
    "movetype": "mounted",
    "moveaudio": "Unit:Move:Horse",
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "affiliation": "bad",
    "decalImageKey": "green-helmet",

    "primaryItem": {
        "name": "Axe",
        "element": "earth",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "axe",
    },
}

//////////////////////
// FIGHTER ARMORED //
////////////////////

units["swordknight"] = {
    "jobKey": "swordknight",
    "jobName": "Swordknight",
    "fequivalent": "Swordknight",
    "moverange": 1,
    "movetype": "armored",
    "moveaudio": "Unit:Move:Armored",
    "maxarmor": 10,
    "armortype": "steel",
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "affiliation": "bad",
    // "attackspeed": 5,
    // "luck": 0,
    "decalImageKey": "red-shield",

    "primaryItem": {
        "name": "Sword",
        "element": "fire",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "sword",
    },
}

units["spearknight"] = {
    "jobKey": "spearknight",
    "jobName": "Spearknight",
    "fequivalent": "Lancerknight",
    "moverange": 1,
    "movetype": "armored",
    "moveaudio": "Unit:Move:Armored",
    "maxarmor": 10,
    "armortype": "steel",
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "affiliation": "bad",
    "decalImageKey": "blue-shield",

    "primaryItem": {
        "name": "Spear",
        "element": "water",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "spear",
    },
}

units["axeknight"] = {
    "jobKey": "axeknight",
    "jobName": "Axeknight", // ??
    "fequivalent": "Axeknight",
    "moverange": 1,
    "movetype": "armored",
    "moveaudio": "Unit:Move:Armored",
    "maxarmor": 10,
    "armortype": "steel",
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "affiliation": "bad",
    "decalImageKey": "green-shield",
    "weaponImageKey": "axe",

    "primaryItem": {
        "name": "Axe",
        "element": "earth",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "axe",
    },
}

///////////
// MAGE //
/////////

units["mage"] = {
    "jobKey": "mage",
    "jobName": "Mage",
    "fequivalent": "Mage",
    "moverange": 2,
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "affiliation": "bad",

    "primaryItem": {
        "name": "Staff",
        "element": "fire",
        "attacktype": "magic",
        "attackrange": 2,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "red-staff"
    },
}

units["priest"] = {
    "jobKey": "priest",
    "jobName": "Priest",
    "fequivalent": "Priest",
    "skillKeys": ["restore-health"],
    "moverange": 2,
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "affiliation": "bad",

    "primaryItem": {
        "name": "Staff",
        "element": "water",
        "attacktype": "magic",
        "attackrange": 2,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "blue-staff",
    },
}

units["nobody"] = {
    "jobKey": "nobody",
    "maxhealth": 20,
}

units["shaman"] = {
    "jobKey": "shaman",
    "jobName": "Shaman",
    "fequivalent": "Shaman",
    "moverange": 2,
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "affiliation": "bad",

    "primaryItem": {
        "name": "Staff",
        "element": "earth",
        "attacktype": "magic",
        "attackrange": 2,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "green-staff",
    },
}

// pirates-specific, move to pirates/unitJobs.js
units["barrel"] = {
    "jobKey": "barrel",
    // "type": "thing",
    "role": "barrel",
    "properties": ["no healthbar", "no rockout"],
    "moverange": 0,
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "affiliation": "nothing of concern",
    "imageUrl": require("@frog/source/assets/images/pirate-tactics/barrel.png"),
}

export default units
